import React, { useEffect, useState } from 'react';
import "../components/styles/SearchPage.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SearchPage = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setSearchTerm('');  // 페이지 로드 시 입력 창 초기화
    }, []);

    useEffect(() => {
        const getProductList = async () => {
            try {
                const response = await fetch("/api/items", {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });

                const data = await response.json();
                if (response.ok) {
                    const sortedProducts = [...data.items].sort((a, b) => b.rating - a.rating);  // 인기순 정렬
                    setProducts(sortedProducts);
                    setLoading(false);
                } else {
                    // 본문은 위에서 이미 읽었다. 다시 json()을 부르면 던진다.
                    setError(data?.message || "상품 데이터 불러오기에 실패했습니다.");
                    setLoading(false);
                }
            } catch (err) {
                setError("상품 데이터를 불러오는 중 오류가 발생했습니다.");
                setLoading(false);
                console.error(err);
            }
        };
        getProductList();
    }, []);

    useEffect(() => {
        const fetchSuggestions = async () => {
            if (searchTerm.trim() === '') {
                setSuggestions([]);
                return;
            }

            try {
                const response = await axios.get(`/api/search/suggestions?q=${searchTerm}`);
                setSuggestions(response.data);
            } catch (error) {
                console.error('Error fetching suggestions:', error);
            }
        };

        const delayDebounceFn = setTimeout(() => {
            fetchSuggestions();
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const getProductDetail = (itemId) => {
        navigate(`/products/${itemId}`);
    };

    return (
        <div className="search-page">
            <input
                type="text"
                placeholder="검색어를 입력해주세요"
                value={searchTerm}
                onChange={handleInputChange}
                className={`search-input ${searchTerm ? 'active' : ''}`}
            />
            {searchTerm && suggestions.length > 0 && (
                <div className="suggestions">
                    {suggestions.map((item, index) => (
                        <div key={item.itemId || index} className="suggestion-item" role={'button'} onClick={() => getProductDetail(item.itemId)}>
                            {item.itemName}
                        </div>
                    ))}
                </div>
            )}

            <div className="related-products-search">
                <h2>인기 상품</h2>
                {products.length === 0 ? (
                    <div className="sc-empty">
                        <div className="sc-empty__title">현재 판매 중인 상품이 없습니다</div>
                        <div className="sc-empty__desc">다른 검색어로 찾아보시거나 맞춤 개발로 문의해 주세요.</div>
                        <button type="button" className="sc-btn" onClick={() => navigate("/custom-product-first")}>
                            맞춤 개발 문의
                        </button>
                    </div>
                ) : (
                    <div className="sch-productgrid">
                        {products.slice(0, 4).map((product, index) => (
                            <div
                                key={product.itemId ?? index}
                                className="sc-product"
                                role="button"
                                onClick={() => getProductDetail(product.itemId)}
                            >
                                <div className="sc-product__thumb">
                                    <div className="sc-product__badges">
                                        {product.category === 'DISCOUNTED' && <span className="sc-badge sc-badge--sale">할인</span>}
                                        {product.category === 'NEW' && <span className="sc-badge sc-badge--new">NEW</span>}
                                        {product.category === 'BEST' && <span className="sc-badge sc-badge--best">BEST</span>}
                                    </div>
                                    {product.thumbFileName && product.thumbPath ? (
                                        <img src={product.thumbPath} alt={product.itemName} />
                                    ) : (
                                        <span className="sc-caption">No Image</span>
                                    )}
                                </div>

                                <div className="sc-product__body">
                                    <div className="sc-product__name">{product.itemName}</div>
                                    <div className="sc-product__desc">{product.itemDescription}</div>
                                    <div className="sc-product__meta">
                                        <span className="sc-stars">
                                            {[1,2,3,4,5].map((i) => (
                                                <span key={i} className={i <= Math.round(product.rating || 0) ? "" : "off"}>★</span>
                                            ))}
                                        </span>
                                        <span className="sc-stars__num">{(product.rating || 0).toFixed(1)}</span>
                                        <span>· 리뷰 {product.reviewCount ?? 0}</span>
                                    </div>
                                    <div className="sc-product__price">
                                        {product.discountRate > 0 && (
                                            <span className="sc-price__rate">{product.discountRate}%</span>
                                        )}
                                        {product.costPrice > product.salePrice && (
                                            <span className="sc-price__was">{product.costPrice?.toLocaleString()}원</span>
                                        )}
                                        <span className="sc-price__now">{product.salePrice?.toLocaleString()}원</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchPage;
